import React, { useContext } from "react";
import styled from "@emotion/styled";
import Context from "./Context";

const FiltersTitle = () => {
	const {
		data: { filters, language, indexPage },
	} = useContext(Context);

	const filtersTitleText = () => {
		if (language === "en") {
			if (indexPage === "stories") {
				return `Browse by ${filters[0].region.title}`
			}

			return `Browse by ${filters[0].category.title}`
		}

		if (indexPage === "stories") {
			return `Parcourir par ${filters[0].region.title}`
		}

		return `Parcourir par ${filters[0].category.title}`;
	};

	if (filters.length === 0) return null;

	return 	<FiltersTitleText>{filtersTitleText()}</FiltersTitleText>
}

export default FiltersTitle;

const FiltersTitleText = styled.h4`
	margin-bottom: 3rem;
`;
